@if (chartData) {
  <app-pchart type="bar" [data]="chartData" />
}
